import { fetchMetafieldDetailsForProducts } from './fetchMetaObjects';

export async function onSuccessfulAPICall(response) {
  const productIds = response.products.map((item) => item.id);
  const productDetailsToMetafields = await fetchMetafieldDetailsForProducts(productIds);

  response.products = response.products.map((product) => {
    return {
      ...product,
      metafields: {
        ...product.metafields,
        ...productDetailsToMetafields[product.id]
      }
    };
  });

  return response;
}
